/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { Link } from 'site-modules/shared/components/link/link';
import { PAGE_URL } from 'site-modules/shared/constants/page-urls';
import { PersonalizedSearchEntities } from 'site-modules/personalized-search/constants/entities';
import { COMPONENTS } from 'site-modules/personalized-search/constants/components';
import { SearchRenderer } from 'site-modules/personalized-search/search-renderer/search-renderer';
import { objectToQueryString } from 'site-modules/shared/utils/string';
import { DEALERSHIP_CREATIVE_ID } from 'site-modules/shared/constants/personalized-search/personalized-search';

import './dealership.scss';

export function Dealership({
  componentParams,
  onUpdateFilters,
  componentPath,
  onRendered = noop,
  initialFilters = {},
}) {
  useEffect(() => {
    onRendered();
  }, [onRendered]);
  const query = objectToQueryString({ make: initialFilters?.make || 'all' });

  return (
    <section className="dealership" data-tracking-parent={DEALERSHIP_CREATIVE_ID}>
      <div className="base-inner-width px-1 px-md-0_5 px-lg-0 mx-md-auto">
        <h2 className="visually-hidden">Dealerships</h2>
        <ul className="list-unstyled m-0">
          {componentParams.map((dealershipItem, idx) => (
            <li key={idx}>
              <SearchRenderer
                componentParams={dealershipItem}
                parentComponentName={COMPONENTS.DEALERSHIP}
                componentPath={componentPath}
                order={idx + 1}
                onUpdateFilters={onUpdateFilters}
              />
            </li>
          ))}
        </ul>
        <div className="mt-1_5 mb-2">
          <Link to={`${PAGE_URL.DEALERSHIPS}?${query}`}>
            <span className="me-0_25 text-underline">Show more dealerships</span>
            <i className="icon-arrow-right3 size-12" aria-hidden />
          </Link>
        </div>
      </div>
    </section>
  );
}

Dealership.propTypes = {
  componentParams: PropTypes.arrayOf(
    PropTypes.shape({
      components: PropTypes.arrayOf(PropTypes.string),
      dealershipItem: PersonalizedSearchEntities.dealership,
    })
  ).isRequired,
  onUpdateFilters: PropTypes.func.isRequired,
  componentPath: PropTypes.string.isRequired,
  onRendered: PropTypes.func,
  initialFilters: PropTypes.shape({
    make: PropTypes.string,
  }),
};
